import React from "react";

function TezosHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Tezos Blockchain Solutions Partner
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Xeer Technology, a trusted leader in Tezos Blockchain
                    Development, offers cutting-edge solutions to help
                    businesses leverage the efficiency, security, and
                    scalability of Tezos.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TezosHero;
